import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { Amplify } from 'aws-amplify'
import Output from '../../backend/amplify_outputs.json'
import { datadogRum } from '@datadog/browser-rum';
import { angularPlugin } from '@datadog/browser-rum-angular';
import { environment } from './environments/environment';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

// Register Chart.js components before bootstrap

Amplify.configure(Output);

// Register French locale with both 'fr' and 'fr-FR' identifiers
registerLocaleData(localeFr, 'fr');
registerLocaleData(localeFr, 'fr-FR');

// Datadog RUM, en parallèle de PostHog : l'enregistrement de session PostHog
// ne fonctionne pas depuis Azure Virtual Desktop, d'où l'essai d'un second
// outil. Initialisé AVANT le bootstrap pour que le plugin Angular voie la
// première navigation. L'utilisateur est posé par AppComponent (setUser).
datadogRum.init({
  applicationId: '6687c44f-0a3c-4c59-9fd1-1bc6a04f9a95',
  clientToken: 'pubaa9cf4f174dd1550ffc9e1f5423bf68e',
  site: 'datadoghq.eu',
  service: 'lp-gelo',
  env: environment.datadogEnv,
  version: environment.appVersion,
  sessionSampleRate: 100,
  // Toutes les sessions : le but de l'essai est le replay, et le parc
  // d'utilisateurs est petit.
  sessionReplaySampleRate: 100,
  trackResources: true,
  trackUserInteractions: true,
  trackLongTasks: true,
  // Même politique que PostHog (maskAllInputs: false) ; masquer un élément
  // au cas par cas avec data-dd-privacy="mask".
  defaultPrivacyLevel: 'allow',
  plugins: [angularPlugin({ router: true })],
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));

